import { Authority } from "@dataone/lib";
import { Divider } from "antd";
import { styled } from "styled-components";
import { withAuth } from "../../auth/helpers/hoc";
import { useNavigate } from "react-router-dom";

interface HelpCenterHeaderProps {
  secondTitle?: string;
  thirdTitle?: string;
}

const HelpCenterHeader = ({
  secondTitle,
  thirdTitle,
}: HelpCenterHeaderProps) => {
  const navigate = useNavigate();
  const handleNavigate = (path: string) => {
    navigate(path);
  };
  function formatString(input: string): string {
    return "/support/" + input.toLowerCase().replace(/\s+/g, "-");
  }
  return (
    <StyledHelpCenterHeader>
      {secondTitle ? (
        thirdTitle ? (
          <>
            <>
              <PreviousTitle onClick={() => handleNavigate("/support")}>
                Help center
              </PreviousTitle>
              <h3 style={{ color: "#CFD5FF" }}> / </h3>
              <PreviousTitle
                onClick={() => handleNavigate(formatString(secondTitle))}
              >
                {secondTitle}
              </PreviousTitle>
              <h3 style={{ color: "#CFD5FF" }}> / </h3>
              <HeaderTitle>{thirdTitle}</HeaderTitle>
            </>
          </>
        ) : (
          <>
            <PreviousTitle onClick={() => handleNavigate("/support")}>
              Help center
            </PreviousTitle>
            <h3 style={{ color: "#CFD5FF" }}> / </h3>
            <HeaderTitle>{secondTitle}</HeaderTitle>
          </>
        )
      ) : (
        <HeaderTitle>Help center</HeaderTitle>
      )}

      <Divider />
    </StyledHelpCenterHeader>
  );
};

export default HelpCenterHeader;

const StyledHelpCenterHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0px 22px;
  .ant-divider-horizontal {
    width: 90% !important;
    min-width: 40% !important;
  }
  .ant-divider {
    border-block-start: 1.5px solid #eff1fd;
    border-radius: 17px;
    margin-top: 28px;
  }
`;

const HeaderTitle = styled.h3`
  color: #4974f6;
  font-size: 19px;
  min-width: fit-content;
  cursor: pointer;
`;
const PreviousTitle = styled.h3`
  font-size: 19px;
  min-width: fit-content;
  cursor: pointer;
`;
